/**
 * Dispatcher for Backbone and React apps communication
 */
import { EventEmitterService } from 'js/services/eventEmitter.service';

export class Dispatcher extends EventEmitterService {
    dispatch(eventName, ...args) {
        this.trigger(eventName, ...args);
    }

    listen(eventName, callback) {
        this.on(eventName, callback);
    }
}

export const dispatcher = new Dispatcher();
